<template>
  <div class="container pb-10">
    <div class="flex items-center mb-10">
      <a href="/admin/forms/project-closeout" class="text-gray-900 no-underline">
        <d-icon icon="arrow-left" size="1x" class="mr-3" />
        <span class="text-xl">Back To Listing Page</span>
      </a>
    </div>

    <div class="flex flex-wrap -mx-5">
      <div class="px-5 w-full md:w-1/2">
        <h2>Project Details</h2>
        <div>
          <div class="mb-3">
            <p class="font-bold">
              Project Name
            </p>
            <p v-text="computedProject.name" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              QCP-Issued Project Number
            </p>
            <p v-text="computedProject.number" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              City
            </p>
            <p v-text="computedProject.city" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              State
            </p>
            <p v-text="computedProject.stateProvince" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Country
            </p>
            <p v-text="computedProject.country" />
          </div>
        </div>
      </div>

      <div class="px-5 w-full md:w-1/2">
        <h2>Closeout Information</h2>
        <div>
          <div class="mb-3">
            <p class="font-bold">
              Close Submitted By
            </p>
            <p v-text="computedSubmissionDetails.closeoutInformationSubmittedBy" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Submitter Email
            </p>
            <p v-text="computedSubmissionDetails.submitterEmail" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Company Name
            </p>
            <p v-text="computedSubmissionDetails.companyName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Project Completion Date
            </p>
            <p>
              {{ computedProject.dateCompleted | formatShortDate }}
            </p>
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Estimated Completion Date
            </p>
            <p>
              {{ computedProject.estimatedCompletionDate | formatShortDate }}
            </p>
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Final contract Amount
            </p>
            <p v-text="computedSubmissionDetails.finalContractAmount" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('update:submissionDetails', value);
        },
      },

      computedProject() {
        return this.submissionDetails.project;
      },
    },
  };
</script>